import { ElLoading } from 'element-plus';
import Helper from './common';

let loadingInstance : ReturnType<typeof ElLoading.service>;

const startLoading = (options:any = { t: '加载页面...', background:'rgba(255,255,255,0.6)'})=>{
    loadingInstance = ElLoading.service({
        fullscreen: true,
        lock: true,
        customClass: 'loading-logo',
        text: Helper.getVal(options.t) == null ? '加载页面...' : options.t,
        background: options.background
    })
}

const endLoading = ()=>{
    loadingInstance.close();
}

let loadingQueueCount:number = 0;
export const showLoading = (options:any=null)=>{
    if(loadingQueueCount===0){
      if(options == null) options = { t: '加载页面...', background: 'rgba(255,255,255,0.6)' }
        startLoading(options);
    }
    loadingQueueCount++;
}

export const hideLoading = ()=>{
    if(loadingQueueCount <= 0) return;
    loadingQueueCount--;
    if(loadingQueueCount===0){
        endLoading();
    }
}